module.exports = __webpack_public_path__ + "media/Icons/Alert-58222b30.png";